<script>
import _ from "lodash";
import { Btn, Popover } from "uiv";
export default {
  props: { src: { type: Object, required: true } },
  components: { Btn, Popover },
  data() {
    return {
      id: _.uniqueId("desglose-popover_")
    };
  }
};
</script>

<template>
  <div class="desglose">
    <btn type="link" size="xs" :id="id">
      <i class="fa fa-exclamation-circle"></i>
    </btn>

    <popover :target="'#' + id" custom-class="rules-popover">
      <template slot="popover">
        <table class="table table-condensed">
          <tbody>
            <tr v-for="(item, key ) in src.desglose" :key="key" :class="item.class">
              <td class="concepto" v-text="item.nombre"></td>
              <td class="moneda" v-text="item.moneda"></td>
              <td class="monto" v-text="item.monto"></td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th class="concepto">Total</th>
              <th class="moneda" v-text="src.moneda"></th>
              <th class="monto" v-text="src.total"></th>
            </tr>
          </tfoot>
        </table>
      </template>
    </popover>
  </div>
</template>

<style lang="scss" scoped>
.desglose {
  display: inline-block;

  .btn {
    > .fa {
      font-size: 15px;
      line-height: 20px;
    }
  }
}
</style>